import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEtsyComponent } from './simple-icons-etsy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEtsyComponent ],
    exports:      [ SimpleIconsEtsyComponent ],
    bootstrap:    []
})
export class SimpleIconsEtsyModule {}
